/**
 * Campaign Tracker
 *
 * Public exports for the campaign tracking module.
 * Part of BEC-20520: Campaign Tracker with Salesforce
 */

export * from './types';
export * from './constants';
export * from './cookieManager';
export * from './utmFields';
export * from './checkoutMetadata';
export * from './userMetadata';
